import { useTranslation } from 'react-i18next';
import {
  matchPath,
  useLocation,
  useParams,
} from 'react-router-dom';
import { AppDispatch, RootState } from '../../template/store';
import { useDispatch } from 'react-redux';
import { toggleDocumentHistoryColumnShort } from '../../blDetails/slices/documentHistorySlice';
import { useSelector } from 'react-redux';
import { Button, Card, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faCopy, faEdit } from '@fortawesome/free-regular-svg-icons';
import { Form } from 'react-bootstrap';
import { useEffect, useState, useCallback, ChangeEvent, useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAsyncDebounce } from 'react-table';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import {
  approveRejectPickUp,
  fetchPickupCFSICDName,
  getCFSNameList,
  getInstructionList,
  getOBLDetails,
  getPickUp,
  getPickupCFSName,
  getPickupList,
  getReleaseTypeList,
  getRequestInstructionConfig,
  getRequestInstructionConfigByType,
  getReturnTypeList,
  savePickUpInstruction,
} from '../../dashboard/actions/instruction';
import {
  faCheck,
  faRedo,
  faSave,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { error, profile } from 'console';
import { toast } from 'react-toastify';
import { AESDecrypt, encryptAndEncode } from '../../../../encrypt-util';
import i18next from 'i18next';
import { commonApproveReject } from '../../dashboard/actions/instruction';
import { updateDashbaordRefresh, updateSortStateDataTable } from '../../../common/components/DataTable/slices/DataTable';

import { useBackNavigation } from '../../../../hooks/BackNavigation';
import useDataCountry from '../../../../hooks/useDataCountry';
import SnoozedToButton from '../../instructionDashboard/components/SnoozedTo';
import useBlCountry from '../../../../hooks/useBlCountry';
import { getUnprefixedPathname } from '../../../../helpers/utils';
import { useFormNavigationWarning } from '../../../../hooks/useFormNavigationWarning';
import UnsavedChangesModal from '../../../../components/common/UnsavedChangesModal';
import { setDirty } from '../../formDirtySlice';
import AsyncSelect from 'react-select/async';
import UploadIndicator from '../../../../components/common/UploadIndicator';
import axiosInstance from '../../../../axiosSetup';
import { getAppConfig } from '../../../common/actions/userDetails';
import UploadThing from '../../../../components/common/UploadThing';
import { updateSelectedAttachmentFilePath, updateSelectedAttachmentName, updateSelectedFileServerPath} from './instructionSlice/PickupSlice';
import { openDocumentInNewTab } from '../../../../helpers/openDocumentInNewTab';


const PickUpInstruction = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { blNum, encryptdoc } = useParams();
  const docId = AESDecrypt(encryptdoc);
  console.log(useParams(), "useparams")
  const selectedRouter = useSelector(
    (state: RootState) => state.documentHistory.selectedRouter
  );

  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  
  const onBack = useBackNavigation();

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const instructionDashboardList = useSelector(
    (state: RootState) => state.dashboard.instructionDashboardList
  );
  const dataObl = useSelector((state: RootState) => state.instructionSlice.dataObl)
  const dashboardListArray = Array.isArray(instructionDashboardList)
    ? instructionDashboardList
    : Array.isArray(instructionDashboardList?.result)
      ? instructionDashboardList.result
      : [];
  const matchingInstruction = dashboardListArray.find((item: any) => item.bl_id === AESDecrypt(blNum));

  //  const displayNumber = dataObl?.number || matchingInstruction?.bl_no || '';
  const [blNumDisplay, setBlNumDisplay] = useState('');
  const [cfsNameView, setCfsNameView] = useState('');

  const oblNumber = useSelector((x: RootState) => x.oblDetails.oblForm.number)
  const [loiUpload, setLoiUpload] = useState('');


  // const [fileName, setFileName] = useState('');
  // console.log(fileName,"fileName")

  // const [selectedFileServerPath, setSelectedFileServerPath] = useState<Array<string | null>>([null, null])
  const [loadingFileState, setLoadingFileState] = useState<number | undefined>(undefined)
  const [attachedFileSize, setAttachedFileSize] = useState(0)

  const selectedAttachmentFilePath = useSelector(
    (state: RootState) => state.pickup.selectedAttachmentFilePath
  );
  const selectedAttachmentName = useSelector(
    (state: RootState) => state.pickup.selectedAttachmentName
  );
  const selectedFileServerPath = useSelector(
    (state: RootState) => state.pickup.selectedFileServerPath
  );

  const displayNumber = blNumDisplay ? blNumDisplay : oblNumber ? oblNumber : '';
  const blEventId_docInsDashboard: any = useSelector(
    (state: any) => state.dashboard.instructionDashboardList.result.filter((Item: any) => Item.bl_id == AESDecrypt(blNum))[0]?.bl_event_id
  );

  const disabledPath = [
    { path: `${APP_PATH_PREFIX}/bl/:blNum/808/:eventId` },
    { path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/808/:eventId` },
    { path: `${APP_PATH_PREFIX}/instruction/:blNum/808/:blId` },
    {
      path: `${APP_PATH_PREFIX}/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[3] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/payment/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    { path: `${APP_PATH_PREFIX}/instruction/:blNum/:encrypt/:encryptdoc` },
  ].some(({ path, condition }: { path: string; condition?: boolean }) => {
    return (
      (condition ?? true) &&
      matchPath({ path, caseSensitive: true, end: true }, location.pathname)
    );
  });

  console.log(disabledPath, "disabledPath")

  const dataCountry = useDataCountry();
  const [blCountry, setBlCountry] = useBlCountry(
    disabledPath ? "view" : "new",
    "import",
    808
  );
  const [blNumber, setBLNumber] = useState<any>('')
  const rbac = useSelector((state: RootState) => state.userProfile);
  const pickUpLocList = useSelector(
    (state: RootState) => state.invoiceChange.releaseTypeList
  );

  const pickUpForm = useSelector((state: RootState) => state.pickup.pickUpData);

  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );

  const [pickUpLoc, setPickUpLoc] = useState('0');
  const [rejectRemarks, setRejectionRemarks] = useState('');
  const [userRemark, setUserRemark] = useState('');
  const [emailId, setEmailId] = useState('');
  const [status, setStatus] = useState('');
  const [pickUpId, setPickUpId] = useState(null);
  const [showCfsIcdName, setShowCfsIcdName] = useState('No');
  const [showLoiAttachment, setShowLoiAttachment] = useState('No');
  const [cfsIcdNameList, setCfsIcdNameList] = useState([]);

  const isDirty = useSelector((state: RootState) => state.formDirty.isDirty);
  type FormValues = {
    pickUpLoc: string;
    destuffingTp: string;
    returnLoc: string;
    rejectRemarks: string;
    userRemark: string;
    cfsIcdName: string;
    byteArr: string;
    loiUpload: any;

  };

  const [isEditMode, setIsEditMode] = useState(false);

  const disableFields =
    !isEditMode && (
      profileDetails?.partnerType === 'liner' ||
      (!!disabledPath && profileDetails?.partnerType !== 'liner'));

  const validationSchema = Yup.object().shape({
    pickUpLoc: Yup.string().required(
      t('resource_3:isRequired', { field: t('resource_2:releaseType') })
    ).notOneOf(['0'], t('resource_3:isRequired', { field: t('resource_2:releaseType') })),
    userRemark: Yup.string().when('$fieldConfig', (fieldConfig, schema) =>
      fieldConfig?.userRemark?.mandatory
        ? schema.required('User Remark is required')
        : schema
    ),
    // cfsIcdName: Yup.string().when('$fieldConfig', (fieldConfig, schema) =>
    //   fieldConfig?.cfsIcdName?.mandatory
    //     ? schema
    //       .test(
    //         'not-zero',
    //         'CFS/ICD Name is required',
    //         (value: any) => value && value !== '0'
    //       )
    //       .required('CFS/ICD Name is required')
    //     : schema
    // ),
    cfsIcdName: Yup.mixed().when('$fieldConfig', (fieldConfig, schema) =>
  fieldConfig?.cfsIcdName?.mandatory
    ? schema
        .test(
          'not-null',
          'CFS/ICD Name is required',
          (value: any) => value !== null && typeof value === 'object' && !!value.value
        )
        .required('CFS/ICD Name is required')
    : schema
),


  });

  const fieldConfig = useMemo(() => {

    return {
      pickUpLoc: {
        mandatory: true,
        disabled: disableFields,
        visible: true,
      },
      cfsIcdName: {
        mandatory: (showCfsIcdName ?? "").toLowerCase() === 'yes' && !(disableFields || pickUpLoc == '0' || pickUpLoc == '1001'),
        disabled: disableFields || pickUpLoc == '0' || pickUpLoc == '1001',
        visible: (showCfsIcdName ?? "").toLowerCase() == 'yes',
      },
      loiUpload: {
        mandatory: (showLoiAttachment ?? "").toLowerCase() == 'yes',
        disabled: disableFields,
        visible: (showLoiAttachment ?? "").toLowerCase() == 'yes' &&
          (
            !docId ||
            isEditMode ||
            !!selectedAttachmentFilePath
          )
      },
      rejectRemarks: {
        mandatory: false,
        disabled: profileDetails?.partnerType === "customer" ||
          pickUpForm?.status === 'Completed' ||
          pickUpForm?.status === 'Rejected' ||
          profileDetails?.partnerType === 'customer'
          ? true
          : false
        ,
        visible: (rbac.rbacDetails.returnCntApproveReject === 'Y' ||
          disableFields),
      },
      userRemark: {
        mandatory: false,
        disabled: disableFields,
        visible: true,
      },
      status: {
        mandatory: false,
        disabled: true,
        visible: disableFields,
      },
    };
  }, [
    disableFields,
    showCfsIcdName,
    pickUpLoc,
    showLoiAttachment,
    profileDetails?.partnerType,
    pickUpForm?.status,
    rbac,
    docId,
    selectedLinerId,
    isEditMode
  ])

  const buttonConfig = useMemo(() => {

    return {
      approve: {
        disabled: pickUpForm?.status === 'Completed' ||
          pickUpForm?.status === 'Rejected'
          ? disableFields
          : false,
        visible: blCountry === dataCountry &&
          rbac.rbacDetails.pickUpApproveReject === 'Y' && pickUpForm?.status !== 'Completed' &&
          pickUpForm?.status !== 'Rejected',
      },
      reject: {
        disabled: pickUpForm?.status === 'Completed' ||
          pickUpForm?.status === 'Rejected'
          ? disableFields
          : false,
        visible: blCountry === dataCountry &&
          rbac.rbacDetails.pickUpApproveReject === 'Y' && pickUpForm?.status !== 'Completed' &&
          pickUpForm?.status !== 'Rejected',
      },
      submit: {
        disabled: false,
        visible: !(blCountry === dataCountry && rbac.rbacDetails.pickUpApproveReject === 'Y')
          && rbac.rbacDetails.pickUpCUD && (!encryptdoc || !disableFields || isEditMode)
      },
      edit: {
        disabled: false,
        visible: status === 'Submitted' && !isEditMode && !(blCountry === dataCountry && rbac.rbacDetails.pickUpApproveReject === 'Y') && rbac.rbacDetails.pickUpCUD && encryptdoc && disableFields
      },
      reset: {
        disabled: false,
        visible: !(blCountry === dataCountry && rbac.rbacDetails.pickUpApproveReject === 'Y')
          && rbac.rbacDetails.pickUpCUD && (!encryptdoc || !disableFields || isEditMode)
      },
    };
  }, [
    pickUpForm?.status,
    disableFields,
    blCountry,
    dataCountry,
    rbac,
    encryptdoc,
    isEditMode,
    status,
    docId,
    selectedLinerId
  ])

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    clearErrors,
    setError,
    trigger,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    context: {
      fieldConfig
    },
    mode: 'onChange',
  });


  const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
    isChanged: isDirty,
    isEditable: true,
    onConfirm: onBack // or onBack, or your navigation function
  });

  const handleStayOnPage = () => {
    handleCancel();
  };

  const handleLeavePage = () => {
    onBack()
  };
  /* useEffect(()=>{
     dispatch(
    getOBLDetails({
      blNumber: AESDecrypt(blNum) || null,
      selectedLinerId:
        profileDetails.partnerType === 'liner'
          ? profileDetails?.partnerId
          : selectedLinerId,
    })
  ).then((res:any) => {
      console.log("resposeee",res)
      if (res) {
        setBLNumber(res.payload.number); // or res.payload?.data?.blNumber based on structure
      }
    });
        
  
  },[blNum]) */
  useEffect(() => {
    if (!disabledPath) {
      setValue('pickUpLoc', '0');
      setValue('destuffingTp', '1');
      setValue('returnLoc', '0');
      setLoadingFileState(undefined);
      dispatch(
        updateSelectedFileServerPath([])
      );
      dispatch(
        updateSelectedAttachmentName('')
      );
      dispatch(updateSelectedAttachmentFilePath(null))
    }
  }, [disabledPath, setValue]);

  const _onCloseForm = () => {
    function extractValuesFromUrl(url: any) {
      const params = new URLSearchParams(url);
      const sortParam = params.get('sort');

      if (sortParam) {
        const arr: any = sortParam.split('%2C');
        return arr;
      } else {
        return [];
      }
    }

    if (isDirty) {
      onBack()
      return;
    }

    dispatch(toggleDocumentHistoryColumnShort(false));
    setTimeout(() => {
      onBack();

      if (selectedRouter === 'instruction') {
        if (window.location.search) {
          const paramVal = extractValuesFromUrl(window.location.search);
          const splitedval = paramVal[0].split(',');
          setTimeout(() => {
            dispatch(
              updateSortStateDataTable({
                key: splitedval[0],
                value: splitedval[1],
              })
            );
          }, 100);
        }
      }
    }, 500);
  };

  const _onPickUpLocChange = useAsyncDebounce((value: string) => {
    setPickUpLoc(value);
  }, 200);





  const onSubmit = handleSubmit(async (payload) => {
    const loadingCheck = loadingFileState != undefined && loadingFileState != 100 && loadingFileState != 0 && loadingFileState != -1
    const docMandateCheck = fieldConfig?.loiUpload?.mandatory && (loadingFileState !=100 || !selectedAttachmentName)
    if (loadingCheck || docMandateCheck) {
      setError('loiUpload', {
        type: 'manual',
        message: 'Please upload a document',
      });
      return;
    }
    clearErrors('loiUpload');
    try {
      dispatch(
        savePickUpInstruction({
          ...payload,
          linerId: selectedLinerId,
          blId: AESDecrypt(blNum),
          country: blCountry,
          loiFilePath: selectedFileServerPath[0],
          loiFileName: selectedAttachmentName,
          pickUpId: docId ? pickUpId : null
        })
      ).then(() => {
        setTimeout(() => {
          dispatch(
            getInstructionList({
              blNum: AESDecrypt(blNum),
              country: dataCountry
            })
          );
          dispatch(updateDashbaordRefresh(true));
          reset();
        }, 2000);
      });
      onBack()
    } catch (err: any) {
      console.error('Error creating pick-up instruction:', err);
    }
  });

  useEffect(() => {
    if (disabledPath && selectedLinerId) {
      dispatch(
        getPickUp({
          docId,
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails?.partnerId
              : selectedLinerId,
        })
      )
        .unwrap()
        .then(async (v: any) => {
          setPickUpId(v?.data?.pickUpId)
          setPickUpLoc(v?.data?.pickUpLoc);
          setValue('pickUpLoc', v?.data?.pickUpLoc);
          setBlNumDisplay(v?.data?.blNo)
          setBlCountry(v?.data?.country);
          setUserRemark(v?.data?.userRemarks);
          setRejectionRemarks(v?.data?.rejectionRemarks);
          setEmailId(v?.data?.email);
          setStatus(v?.data?.status);
          if(v?.data?.loiFilePath){
            setLoadingFileState(100);
          }
          setCfsNameView(v?.data?.pickUpLocationName ?? "")
          // setValue('cfsIcdName', v?.data?.cfsIcdPartnerId);
          if (v?.data?.pickUpLocationName) {
            const options =  await dispatch(getPickupCFSName({ country: blCountry, name: v?.data?.pickUpLocationName })).unwrap()
          // const options = await locationOptions(v?.data?.pickUpLocationName);
          const matched = options?.find(
            (opt:any) => opt.cfsName === v?.data.pickUpLocationName
          );
          if (matched) {
            console.log(matched,"matched")
            setCfsNameView(matched?.cfsName ?? "")
            setValue('cfsIcdName', matched); 
          } else {
            setCfsNameView('')
            setValue('cfsIcdName', '');
          }}
        });
    }
  }, [docId , selectedLinerId, disabledPath, profileDetails, dispatch, setPickUpLoc, setBlCountry, setUserRemark, setRejectionRemarks, setEmailId, setStatus, setValue]);


  useEffect(() => {
    dispatch(getAppConfig('attachment.maxsize'))
      .unwrap()
      .then((response: any) => {
        if (response !== '') {
          setAttachedFileSize(+response.response.data);
        }
      });
  }, []);

  const onApproveReject = (status: string, type: string) => {
    if (status && type) {
      if (status === 'R' && (rejectRemarks === '' || rejectRemarks == null)) {
        toast.dark(t('resource_message:remarksMandatory'));
      } else {
        const pickuplocName:any = watch('cfsIcdName')

        dispatch(
          commonApproveReject({
            instructionId: docId ? parseInt(docId) || null : null,
            instructionType: type || null,
            country: blCountry,
            linerRemarks: rejectRemarks || null,
            customerRemarks: userRemark || null,
            status: status || null,
            emailTo: emailId || null,
            pickUpLocationName: pickuplocName?.cfsName
          })
        )
          .unwrap()
          .then((response: any) => {
            toast.success(response?.responseMsg);
            dispatch(updateDashbaordRefresh(true))
          })
          .catch((error: any) => {
            toast.error(error);
          });

        dispatch(
          getInstructionList({
            blNum: AESDecrypt(blNum),
            country: dataCountry
          })
        );
        onBack()
      }
    }
  };

  const resetForm = () => {
    setPickUpLoc('0');
    setUserRemark('');
    setLoiUpload('');

    setValue('cfsIcdName', '');
    setLoadingFileState(undefined);
    dispatch(
      updateSelectedFileServerPath([])
    );
    dispatch(
      updateSelectedAttachmentName('')
    );
    dispatch(updateSelectedAttachmentFilePath(null));
    reset();
  };



  const language = useSelector((state: RootState) => state.navbarTop.language);
  useEffect(() => {
    if (!blCountry || !selectedLinerId) return
    dispatch(getPickupList({ partnerCountry: blCountry, linerId: selectedLinerId }));
    i18n.changeLanguage(
      `${blCountry}_${language}`
    );
  }, [blCountry, selectedLinerId, language]);

  useEffect(() => {
    setIsEditMode(false);
  }, [docId, blNum]);


  useEffect(() => {
    if (linerId && dataCountry) {
      dispatch(getRequestInstructionConfigByType({
        'linerId': linerId,
        'country': dataCountry,
        "location": '',
        "currency": '',
        "requestType": "instruction",
        "requestIdentifier": "808"
      })).unwrap().then((response: any) => {
        const configJsonString = response.data[0]?.configJson;

        if (configJsonString) {
          try {
            const config = JSON.parse(configJsonString);
            setShowCfsIcdName(config.showCfsIcdName)
            setShowLoiAttachment(config.showLoiAttachment)
          } catch (e) {
            setShowCfsIcdName('No')
            setShowLoiAttachment('No')
          }
        }
      });
    }
  }, [linerId, dataCountry]);

  // Add useEffect for locking left items
  /*   useEffect(() => {
      if (!disabledPath) {
        // Add overlay to lock left items
        const overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '250px'; // Adjust width based on your sidebar width
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'transparent';
        overlay.style.zIndex = '1039';
        overlay.id = 'left-overlay';
        document.body.appendChild(overlay);
  
        return () => {
          // Remove overlay when component unmounts or form is no longer editable
          const overlay = document.getElementById('left-overlay');
          if (overlay) {
            overlay.remove();
          }
        };
      }
    }, [disabledPath]); */

  // Add useEffect for disabling left items
  /*   useEffect(() => {
      if (!disabledPath) {
        // Add style to make left items not clickable
        const style = document.createElement('style');
        style.id = 'left-items-style';
        style.innerHTML = `
          .navbar-vertical, .navbar-vertical .navbar-nav {
            pointer-events: none;
            opacity: 0.7;
          }
        `;
        document.head.appendChild(style);
  
        return () => {
          // Remove style when component unmounts or form is no longer editable
          const style = document.getElementById('left-items-style');
          if (style) {
            style.remove();
          }
        };
      }
    }, [disabledPath]); */
  const handleCopyBL = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    try {

      if (displayNumber) {
        await navigator.clipboard.writeText(displayNumber || '');;
        // toast.success(t('resource_2:copiedToClipboard') as string);
      } else {
        toast.error(t('resource_2:copyFailed') as string);
      }
    } catch (error) {
      console.error('Copy failed:', error);
      toast.error(t('resource_2:copyFailed') as string);
    }
  };

  const PowerofAttorney = () => {

    const liner_country = [['24118', 'KE'], ['24118', 'MZ'], ['24118', 'TG'], ['24118', 'TZ'], ['24118', 'CM']]

    const doc_available = liner_country?.some(((data) => {
      return data[0] == linerId && data[1] == profileDetails?.partnerCountry;
    }))

    if (dataCountry == 'ZA') {
      window.open('/pdf/letterOfAuthorityMASCSIZA.docx', '_blank');
      return
    }
    else if (linerId && profileDetails.partnerCountry && doc_available) {
      const loifilename = `/pdf/loiFormat_${linerId}_${profileDetails.partnerCountry}.docx`;
      window.open(loifilename, '_blank');
      return;
    }
    else {
      window.open('/pdf/letterOfAuthorityMASCSI.docx', '_blank');
    }

    // if (linerId == "24118" && profileDetails.partnerCountry == 'TZ') {
    //   // window.open('/pdf/loiFormat.docx','_blank')

    //   window.open(loifilename, '_blank');
    //   return;
    // }
    // if (linerId == "24118" && profileDetails.partnerCountry == 'KE') {
    //   // window.open('/pdf/loiFormatPILKE.docx','_blank')
    //   window.open(loifilename, '_blank');
    //   return
    // }
    // if (linerId == "24118" && profileDetails.partnerCountry == 'TG') {
    //   // window.open('/pdf/LOIFormatPILTogo.docx', '_blank')
    //   window.open(loifilename, '_blank');
    // }
    // if (linerId == "24118" && profileDetails.partnerCountry == 'MZ') {
    //   // window.open('/pdf/loiFormatPILMZ.docx', '_blank')
    //   window.open(loifilename, '_blank');
    // }

    // if (dataCountry == 'ZA') {
    //   window.open('/pdf/letterOfAuthorityMASCSIZA.docx', '_blank');
    //   return
    // }
    // window.open('/pdf/letterOfAuthorityMASCSI.docx', '_blank');
  };


  const showSnoozeButton = blCountry === dataCountry &&
    rbac.rbacDetails.pickUpApproveReject === 'Y' && pickUpForm?.status !== 'Completed' &&
    pickUpForm?.status !== 'Rejected' && rbac.rbacDetails.snoozeCUD === 'Y' && !location.pathname.includes('/bl');



      const locationOptions = (inputValue: string) =>
        new Promise<any[]>((resolve) => {
          setTimeout(() => {
            dispatch(getPickupCFSName({ country: blCountry, name: inputValue }))
              .unwrap()
              .then((v: any) => {
                resolve(v);
              });
          }, 1500);
        });


  // useEffect(() => {

  //   if (dataCountry && (pickUpLoc == "1002" || pickUpLoc == "1003")) {
  //     dispatch(fetchPickupCFSICDName({
  //       countryCode: dataCountry,
  //       type: pickUpLoc == '1002' ? 'cfs' : pickUpLoc == '1003' ? 'icd' : ""
  //     })).unwrap().then((data: any) => {
  //       setCfsIcdNameList(data)
  //     }).catch((e) => {
  //       setCfsIcdNameList([])
  //     })
  //   }

  // }, [dataCountry, pickUpLoc, docId, isEditMode]);


  const charLimit = (name: string, limit: number) =>
    name && name?.length >= limit ? name?.substring(0, limit) + '...' : name;



  return (
    <Card className='h-100 overflow-auto'>
      <UnsavedChangesModal
        show={showModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />
      <Card.Header className="d-flex align-items-center border-bottom sticky-top bg-white justify-content-between flex-wrap">
        <div className="d-flex align-items-center flex-wrap">
          <FontAwesomeIcon
            icon={faArrowAltCircleLeft}
            className="text-warning cursor-pointer fa-lg me-2"
            onClick={handleBack}
          />
          <h2 className="fs-0 text-primary mb-0">
            {t('resource_2:releaseInstructions')}
          </h2>

          {displayNumber && (
            <div className="d-flex align-items-center ms-3">
              <span className="text-muted me-1"> BL No.</span>
              <span className="fw-bold me-1">{displayNumber || ''}</span>
              <button
                className="btn btn-link p-0"
                onClick={handleCopyBL}
                title="Copy BL number"
              >
                <FontAwesomeIcon icon={faCopy} className="text-primary" />
              </button>
            </div>
          )}
        </div>
      </Card.Header>

      <Card.Body>
        <div className='container'>
          <Form onSubmit={onSubmit} autoComplete='off'>
            <div className='row'>
              {t('resource_message:pickUpInstruction') != '' && (
                <div className='col-lg-12 mb-1'>
                  <Form.Label style={{ color: '#f5822a' }}>
                    <ul style={{ paddingLeft: '15px' }}>
                      {t('resource_message:pickUpInstruction')
                        .split('\n')
                        .map((v: any) => (
                          <li>{v}</li>
                        ))}
                    </ul>
                  </Form.Label>
                </div>
              )}
              {fieldConfig.pickUpLoc.visible && (
                <div className='col-lg-4 mb-3'>
                  <Form.Group controlId='pickUpInstruction.pickUpLoc'>
                    <Form.Label className='fs--1'>
                      {fieldConfig.pickUpLoc.mandatory && <span className='mandatory'>*</span>}
                      {t('resource_2:pickUpLoc')}&nbsp;
                    </Form.Label>
                    <Form.Select
                      aria-label={t('resource_2:pickUpLoc')}
                      {...register('pickUpLoc')}
                      className='fs--1'
                      disabled={fieldConfig.pickUpLoc.disabled}
                      value={pickUpLoc}
                      onChange={(e) => {
                        setPickUpLoc(e.target.value);
                        setValue('pickUpLoc', e.target.value);
                        setValue('cfsIcdName', '');
                        _onPickUpLocChange(e.target.value);
                        dispatch(setDirty());
                        clearErrors()
                      }}
                    >
                      {pickUpLocList.map((option: any) => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.pickUpLoc && <Form.Label className="fs--1 is-invalid mandatory m-0 p-0">
                      {errors.pickUpLoc.message}</Form.Label>}
                  </Form.Group>
                </div>
              )}
              {/* {(blCountry === 'KE' && selectedLinerId === "1") && ( */}

              {/* // )} */}
              {fieldConfig.loiUpload.visible && (
                <div className='col-lg-8 mb-3'>
                  <Form.Group controlId='tableComponent.input5'>
                    <Form.Label className='fs--1 d-flex flex-row'>
                      {/* {isMandatory == 'Y' ? <span className='mandatory'>*</span> : ''} */}
                      {fieldConfig.loiUpload.mandatory && <span className='mandatory'>*</span>}
                      {t("resource_2:uploadDocument")}
                      {/* {fileName && fileName != '' &&
                        <td>
                          <UploadIndicator style={{ marginLeft: '20px' }}
                            progress={loadingFileState}
                            fail={loadingFileState === -1} />
                        </td>} */}
                    </Form.Label>
                    {/* <input
                    id={`${docId}-input`}
                    title='Input'
                    type='file'
                    className={`fs--2 form-control ${errors.byteArr ? 'is-invalid' : ''
                      }`}
                    disabled={disableFields}
                    accept='.pdf'
                    onClick={(e: any) => {
                      e.target.value = ''
                      setFileName('')
                      setSelectedFileServerPath([null, null])
                    }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      console.log(e.target.value)
                      handleFileChange(e);
                      trigger('byteArr');
                      dispatch(setDirty());
                      setLoiUpload(e.target.value);
                    }}
                  /> */}
                    {!disableFields ?
                      (
                        <>
                          <UploadThing
                            name={selectedAttachmentFilePath
                              ? selectedAttachmentName
                              : selectedAttachmentName
                            }
                            loading={loadingFileState ?? 0}
                            disabled={
                              !!disableFields || (loadingFileState != 100 && loadingFileState != -1 && loadingFileState != undefined)
                            }

                            fulfilled={function (name: string, serverPath: string, serverName: string): void {
                              setLoadingFileState(100);
                              dispatch(
                                updateSelectedFileServerPath([serverPath, serverName])
                              );
                              dispatch(
                                updateSelectedAttachmentName(name)
                              );
                              clearErrors('loiUpload');
                            }}

                            failed={function (): void {
                              setLoadingFileState(-1);
                              dispatch(
                                updateSelectedAttachmentName('')
                              );
                              setError('loiUpload', {
                                type: 'manual',
                                message: 'File upload failed or is required',
                              });
                            }}

                            pending={function (loading: number): void {
                              setLoadingFileState(loading);
                            }}

                            clear={() => {/* allowRemove is false */ }}

                            selected={function (name: string): void {
                              dispatch(
                                updateSelectedAttachmentName(name)
                              );
                              setLoadingFileState(0);
                              dispatch(
                                updateSelectedAttachmentFilePath(null)
                              );
                            }}
                            fileLimit={10}
                            fileType={['PDF']}
                            labelWidth='250px'
                            link={!selectedAttachmentFilePath ? undefined : `${process.env.REACT_APP_CLIENT_APP_HOST
                              }/api/edo-rest-v2/v2/common/openDocument?id=${encryptAndEncode(pickUpId)}&moduleTp=PICK_UP&linerId=${encryptAndEncode(profileDetails.partnerType === 'liner'
                                ? profileDetails?.partnerId
                                : selectedLinerId)
                              }&rd=N`}
                            allowRemove={false}
                          />
                          <span
                            onClick={PowerofAttorney}
                            style={{ cursor: 'pointer', fontSize: '14px' }}
                          >
                            <a className='text-primary' style={{ color: '#2c7be5' }}>
                              {t("resource_2:clickHere")}
                            </a>{' '}
                            {t("resource_message:loiFormatDownload")}
                          </span>{' '}
                          <div className='fs--1 is-invalid mandatory m-0 p-0'>
                            {errors.loiUpload?.message?.toString()}
                          </div>

                        </>
                      ) : (
                        <div className='d-flex justify-content-start align-items-center'>

                          <span
                            className='text-primary cursor-pointer fs--1'
														onClick={async () => {
														  await openDocumentInNewTab({
														    url: '/api/edo-rest-v2/v2/common/openDocument',
														    params: {
														      id: encryptAndEncode(pickUpId),
														      moduleTp: 'PICK_UP',
														      linerId: encryptAndEncode(
														        profileDetails.partnerType === 'liner'
														          ? profileDetails?.partnerId
														          : selectedLinerId
														      ),
														    },
														  });
														}}>
                            {charLimit(selectedAttachmentName, 70)}
                          </span>
                        </div>
                      )
                    }

                  </Form.Group>

                  {/* {errors.loiUpload && <Form.Label className="fs--1 invalid-feedback">
                    {errors.loiUpload.message}</Form.Label>} */}
                </div>
              )}
              {fieldConfig.cfsIcdName.visible && (
                <div className='col-lg-5 mb-3'>
                  <Form.Group controlId='pickUpInstruction.cfsIcdName'>
                    <Form.Label className='fs--1'>
                      {fieldConfig.cfsIcdName.mandatory && <span className='mandatory'>*</span>}
                      {selectedLinerId === '24118'
                        ? t('resource_2:cfsIcdNamePIL')
                        : t('resource_2:cfsIcdName')}
                      &nbsp;
                    </Form.Label>
                    {(docId && !isEditMode) ? <>
 
                <Form.Control
                  value={cfsNameView}
                  className={`fs--1 ${errors.cfsIcdName ? 'is-invalid' : ''
                    }`}
                  disabled={true}
                >
                </Form.Control>
 
              </>:

                    <Controller
                      name="cfsIcdName"
                      control={control} 
                      rules={{ required: fieldConfig.cfsIcdName.mandatory ? 'This field is required' : false }}
                      render={({ field, fieldState }) => (
                        <>
                          <AsyncSelect
                            menuPortalTarget={document.body}
                            noOptionsMessage={({ inputValue }) => {
                              return inputValue ? 'No options' : 'Type to search';
                            }}
                            classNames={{
                              control: (state) => {
                                return `dropControl fs--1 asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
                              },
                            }}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({}),
                            }}
                            cacheOptions
                            onChange={(e: any) => {
                              field.onChange(e);
                            }}
                            value={field.value || null}
                            loadOptions={locationOptions}
                            isDisabled={
                              fieldConfig.cfsIcdName.disabled
                            }
                            isClearable={true}
                          />
                          {errors.cfsIcdName && <Form.Label className="fs--1 is-invalid mandatory m-0 p-0">
                            {errors.cfsIcdName.message}</Form.Label>}
                        </>
                      )}
                    />}
                  </Form.Group>
                </div>
              )}
              {fieldConfig.rejectRemarks.visible && (
                <div className='col-lg-4 mb-3'>
                  <Form.Group controlId='pickUpInstruction.rejectionRemark'>
                    <Form.Label className='fs--1'>
                      {fieldConfig.rejectRemarks.mandatory && <span className='mandatory'>*</span>}
                      {t('resource_1:rejectRemark')}
                    </Form.Label>
                    <Form.Control
                      className={'fs--1 form-control'}
                      {...register('rejectRemarks')}
                      as='textarea'
                      onChange={(e) => { setRejectionRemarks(e.target.value); dispatch(setDirty()); }}
                      value={rejectRemarks}
                      maxLength={150}
                      disabled={
                        fieldConfig.rejectRemarks.disabled
                      }
                    />
                  </Form.Group>
                </div>
              )}
              {fieldConfig.userRemark.visible && (
                <div className='col-lg-4 mb-3'>
                  <Form.Group controlId='pickUpInstruction.userRemark'>
                    <Form.Label className='fs--1'>
                      {fieldConfig.userRemark.mandatory && <span className='mandatory'>*</span>}
                      {t('resource_2:userRemark')}
                    </Form.Label>
                    <Form.Control
                      className={'fs--1 form-control'}
                      {...register('userRemark')}
                      as='textarea'
                      onChange={(e) => { setUserRemark(e.target.value); dispatch(setDirty()); }}
                      maxLength={150}
                      value={userRemark}
                      disabled={
                        fieldConfig.userRemark.disabled
                      }
                    />
                  </Form.Group>
                </div>
              )}
              {fieldConfig.status.visible && (
                <div className='col-lg-5 mb-3'>
                  <Form.Group controlId='invoiceChanges.status'>
                    <Form.Label className='fs--1'>
                      {t('resource_1:status')}&nbsp;
                    </Form.Label>
                    <Form.Control
                      className={'fs--1 form-control'}
                      type='text'
                      value={status}
                      disabled={true}
                    />
                  </Form.Group>
                </div>
              )}
              <>
                {(buttonConfig.approve.visible ||
                  buttonConfig.reject.visible ||
                  buttonConfig.edit.visible ||
                  buttonConfig.submit.visible ||
                  buttonConfig.reset.visible) && (
                    <div className='d-flex justify-content-center align-items-center'>
                      {buttonConfig.approve.visible && (
                        <Button
                          disabled={
                            buttonConfig.approve.disabled
                          }
                          onClick={(e) => {
                            onApproveReject('A', 'PICK_UP');
                          }}
                          variant='success'
                          className='me-2 approve'
                          size='sm'
                        >
                          <FontAwesomeIcon
                            icon={faCheck}
                            className='me-2 approve'
                          />
                          {t('resource_1:approve')}
                        </Button>)}
                      {buttonConfig.reject.visible && (

                        <Button
                          variant='danger'
                          className='reject me-2'
                          size='sm'
                          disabled={
                            buttonConfig.reject.disabled
                          }
                          onClick={(e) => {
                            onApproveReject('R', 'PICK_UP');
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTimes}
                            className='me-2 reject'
                          />
                          {t('resource_1:reject')}
                        </Button>
                      )}
                      {showSnoozeButton ? <SnoozedToButton blNum={AESDecrypt(blNum)} blEventId={blEventId_docInsDashboard} /> : ""}

                      {buttonConfig.edit.visible && (

                        <Button
                          className='me-2'
                          type="button"
                          variant='falcon-primary'
                          onClick={(e) => {
                            e.preventDefault()
                            setIsEditMode(true)
                          }}

                          size='sm'
                          disabled={
                            buttonConfig.edit.disabled
                          }
                        >
                          <FontAwesomeIcon icon={faEdit} className='me-2' />
                          {t('resource_1:edit')}
                        </Button>
                      )}
                      {buttonConfig.submit.visible && (

                        <Button
                          className='me-2'
                          variant='falcon-primary'
                          size='sm'
                          type='submit'
                          disabled={
                            buttonConfig.submit.disabled
                          }
                        >
                          <FontAwesomeIcon icon={faSave} className='me-2' />
                          {t('resource_1:submit')}
                        </Button>
                      )}
                      {buttonConfig.reset.visible && (

                        <Button
                          className='me-2'
                          variant='falcon-danger'
                          size='sm'
                          onClick={resetForm}
                          disabled={
                            buttonConfig.reset.disabled
                          }
                        >
                          <FontAwesomeIcon icon={faRedo} className='me-2' />
                          {t('resource_1:reset')}
                        </Button>
                      )}

                    </div>

                  )}

              </>
            </div>
          </Form>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PickUpInstruction;
